import type { FaireProductEntity } from "../../entity_types/product";

export const p_23awqh3pqs: FaireProductEntity = {
  token: "p_23awqh3pqs",
  type: "product",
  name: "Dally Mango Gel Fruit Snack 5.07 fl oz - Case of 10",
  brandToken: "b_7xgwjjb7p6",
  brandName: "Everyday Supply Co",
  imageUrl:
    "https://cdn.faire.com/fastly/021dff1d226623c1422892d7afb807b2836d510766be1eb266de94a8871195c6.jpeg",
  galleryImageUrls: [],
  priceDollars: 44.95,
  description:
    "Everyday Supply Co proudly presents our Dally Mango Gel Fruit Snack. Each 5.07 fl oz serving is packed with the tantalizing taste of mango, perfect for a quick snack or a delicious dessert. This case of 10 ensures you'll have enough to satisfy your cravings. Enjoy the rich flavor of mango in a convenient, ready-to-eat form. It's not just a snack, it's an everyday delight brought to you by a brand you trust. Savor the sweetness of life with Everyday Supply Co.",
  tags: [],
  msrpDollars: 89.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:25.537Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
